/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetLlmUsageQueryResponse, GetLlmUsagePathParams, GetLlmUsage400, GetLlmUsage401, GetLlmUsage403, GetLlmUsage404, GetLlmUsage409, GetLlmUsage500 } from "../../types/platformBillingController/GetLlmUsage.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getLlmUsage } from "../../client/platformBillingController/getLlmUsage.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getLlmUsageQueryKey = (organizationId: GetLlmUsagePathParams["organizationId"] | undefined) => [{ url: '/api/organizations/:organizationId/llm/usage', params: {organizationId:organizationId} }] as const

export type GetLlmUsageQueryKey = ReturnType<typeof getLlmUsageQueryKey>

export function getLlmUsageQueryOptions(organizationId: GetLlmUsagePathParams["organizationId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getLlmUsageQueryKey(organizationId)
        return queryOptions<GetLlmUsageQueryResponse, ResponseErrorConfig<GetLlmUsage400 | GetLlmUsage401 | GetLlmUsage403 | GetLlmUsage404 | GetLlmUsage409 | GetLlmUsage500>, GetLlmUsageQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getLlmUsage(organizationId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get LLM usage summary
 * {@link /api/organizations/:organizationId/llm/usage}
 */
export function useGetLlmUsage<TData = GetLlmUsageQueryResponse, TQueryData = GetLlmUsageQueryResponse, TQueryKey extends QueryKey = GetLlmUsageQueryKey>(organizationId: GetLlmUsagePathParams["organizationId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetLlmUsageQueryResponse, ResponseErrorConfig<GetLlmUsage400 | GetLlmUsage401 | GetLlmUsage403 | GetLlmUsage404 | GetLlmUsage409 | GetLlmUsage500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getLlmUsageQueryKey(organizationId)
         

         const query = useQuery({
          ...getLlmUsageQueryOptions(organizationId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetLlmUsage400 | GetLlmUsage401 | GetLlmUsage403 | GetLlmUsage404 | GetLlmUsage409 | GetLlmUsage500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}